export default {
  fontFamily: "ja-font-family",
  classLang: "ja",
  headlist: [
    // {
    //   text: "ホーム",
    //   url: "/",
    // },
    {
      text: "取引",
      menu: [
        {
          tit: "取引商品",
          list: [
            {
              text: "FX",
              url: "/tradingproduct?index=0",
            },
            {
              text: "コモディティ",
              url: "/tradingproduct?index=1",
            },
            {
              text: "株価指数",
              url: "/tradingproduct?index=2",
            },
            {
              text: "米国株",
              url: "/tradingproduct?index=3",
            },
            {
              text: "ETF",
              url: "/tradingproduct?index=4",
            },
          ],
        },
        {
          tit: "取引関連",
          list: [
            {
              text: "取引口座",
              url: "/TradingAccount",
            },
            // {
            //   text: "取引商品",
            //   url: "/tradingproduct",
            // },
            {
              text: "レバレッジ・証拠金",
              url: "/leverage-margin",
            },
            {
              text: "入出金",
              url: "/funding",
            },
            {
              text: "CFD配当金",
              url: "/dividend",
            },{
              text: "流動性サービス",
              url: "/service",
            },
            {
              text: "フィンテック",
              url: "/technology",
            },
          ],
        },
        {
          tit: "取引ツール",
          list: [
            {
              text: "MT4 ダウンロード",
              url: "/MT4",
            },
            {
              text: "MT5 ダウンロード",
              url: "/MT5",
            },
            {
              text: "EAとインジケーター",
              url: "/tools",
            },
            {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "市場分析",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "EBC研究所",
      menu: [
        {
          tit: "",
          list: [
            {
              text: "学習センター",
              url: "/LearningCenter",
            },
            {
              text: "データセンター",
              url: "/lab",
            },
          ],
        },
      ],
    },
    
    {
      text: "EBCについて",
      menu: [
        {
          tit: "EBCについて",
          list: [
            {
              text: "WHY EBC",
              url: "/about-us",
            },
            {
              text: "サステナビリティ",
              url: "/ESG",
            },
            
            {
              text: "EBC ニュース",
              url: "/LearningCenter?tabId=1",
            },
            {
              text: "よくある質問",
              url: "https://support.ebchelp.com/hc/ja-jp",
            },
            {
              text: "公式チャンネルの認証",
              url: "/official-verification",
            },
          ],
        },
        {
          tit: "パートナー",
          list: [
            {
              text: "FCバルセロナ",
              url: "/FCB",
            },
            {
              text: "オックスフォード大学",
              url: "/partners/oxford",
            },
            {
              text: "パートナーシップ",
              url: "/affiliate-programmes",
            },
            // {
            //   text: "流動性サービス",
            //   url: "/service",
            // },
            // {
            //   text: "フィンテック",
            //   url: "/technology",
            // },
          ],
        },
      ],
    },

    {
      text: "キャンペーン",
      url: "",
      menu: [
        {
          tit: "EBC人気キャンペーン",
          list: [
            {
              text: "第2回 EBC100万ドル取引大会",
              url: "/million-dollar-challenge-2",
            },
            
            {
              text: "シグナル報酬プログラム",
              url: "/pay",
            },{
              text: "他のキャンペーン",
              url: "/activity",
            },
           
          ],
        },
      ],
    },
  ],
  FCA开户: "FCAアカウント",
  立即开户: "口座開設",
  登录: "ログイン",
  官方验证: "公式チャンネルの認証",
  帮助中心: "FAQよくある質問",
  帮助中心Url: "https://support.ebchelp.com/hc/ja-jp",
};
